module.exports = __webpack_public_path__ + "static/img/ZM@2x.f13913fd.jpg";